import { lazy } from "react";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";

const OnlineDsaList = Loadable(
	lazy(() =>
		import("./OnlineDsa").then(({ OnlineDSAList }) => ({
			default: OnlineDSAList,
		}))
	)
);

const ManageOnlineDsa = Loadable(
	lazy(() =>
		import("./ManageOnlineDsa").then(({ ManageOnlineDsa }) => ({
			default: ManageOnlineDsa,
		}))
	)
);

export const OnlineDsaRoutes = [
	{
		path: "/online-dsa-limit",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.LEADS]}
			>
				<OnlineDsaList />
			</AuthorizedRoute>
		),
	},
	{
		path: "/online-dsa-limit/manage",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.LEADS]}
			>
				<ManageOnlineDsa />
			</AuthorizedRoute>
		),
	},
	// {
	// 	path: `${APP_LEADS_ROUTE}/manage/:uuid`,
	// 	exact: true,
	// 	element: (
	// 		<AuthorizedRoute
	// 			allowFullAccess
	// 			moduleIds={[ALLOWED_MODULES.LEADS]}
	// 		>
	// 			<ManageLead />
	// 		</AuthorizedRoute>
	// 	),
	// },
];
